import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";

export default function MissingImagesButton({ onDone }) {
  const [count, setCount] = useState(0);
  const refresh = () => api.get("/admin/businesses/missing-images").then((r) => setCount(r.data.count)).catch(() => {});
  useEffect(() => { refresh(); }, []);
  if (!count) return null;
  const run = async () => {
    const { data } = await api.post("/admin/businesses/generate-missing-images");
    toast.success(`${data.count} image(s) en cours de génération`, { description: "Elles apparaîtront d'ici une minute environ. Vous pourrez les changer à tout moment." });
    setCount(0);
    setTimeout(() => { onDone(); refresh(); }, 20000 * Math.max(1, data.count));
  };
  return (
    <Button data-testid="admin-missing-images-btn" onClick={run} variant="outline" className="rounded-full border-[#E0C173] text-[#1B2A4A] hover:bg-[#E0C173]">
      <Sparkles className="w-4 h-4 mr-1.5" /> Générer les images manquantes ({count})
    </Button>
  );
}
